import React, { createContext, useContext, useMemo } from "react";

import { Feature } from "../configs/featureFlags";
import getFeatureFlags from "../utils/getFeatureFlags";

export interface FeatureFlagContextType {
  flags: Record<Feature, boolean>;
}

export const FeatureFlagContext = createContext<FeatureFlagContextType | null>(
  null
);

export const FeatureFlagProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const flags = useMemo(() => getFeatureFlags(), []);

  return (
    <FeatureFlagContext.Provider value={{ flags }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlag = (flag: Feature): boolean => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error("useFeatureFlag must be used within a FeatureFlagProvider");
  }
  return context.flags[flag] ?? false;
};
